import { FlexCell, FlexRow, LabeledInput, TextInput } from '@epam/loveship'
import { SidebarPanelHeader } from '../../../../components/SidebarPanel/components/SidebarPanelHeader'
import { SidebarPanelMain } from '../../../../components/SidebarPanel/components/SidebarPanelMain'
import { LOCATION_TYPES } from '../../../../constants/values'
import { capitalizeFirstLetter } from '../../../../utils/strings/capitalizeFirstLetter'

type LocationDetailsProps = {
  locationName: string
  locationType: keyof typeof LOCATION_TYPES
}

export const LocationDetails = ({
  locationName,
  locationType,
}: LocationDetailsProps) => {
  return (
    <>
      <SidebarPanelHeader title="Place Info" />

      <SidebarPanelMain withBorderBottom>
        <FlexRow vPadding="12">
          <FlexCell grow={1}>
            <LabeledInput label="Place Name">
              <TextInput
                isReadonly
                value={locationName}
                onValueChange={() => {}}
              />
            </LabeledInput>
          </FlexCell>
        </FlexRow>

        <FlexRow vPadding="12">
          <FlexCell grow={1}>
            <LabeledInput label="Place Type">
              <TextInput
                isReadonly
                value={capitalizeFirstLetter(locationType)}
                onValueChange={() => {}}
              />
            </LabeledInput>
          </FlexCell>
        </FlexRow>
      </SidebarPanelMain>
    </>
  )
}
